/**
 * Какой дизайн трекера человек выбрал: новый (/new) или старый. Запоминается в браузере; по умолчанию — новый.
 * Меняется только кнопками перехода («Новый интерфейс» в старой шапке, «Старый интерфейс» в новой): разделы, которых
 * в новом дизайне ещё нет (чтецы, расписание), открываются в старом и выбор не сбрасывают. Переходы к конкретному проекту
 * (сессия, мессенджер) от выбора не зависят — всегда в новый.
 */
export type Design = 'new' | 'old';

const STORAGE_KEY = 'tracker.design';
const DESIGNS: readonly Design[] = ['new', 'old'];
const DEFAULT_DESIGN: Design = 'new';

/** Страница проектов нового дизайна и параметр выбранного проекта в ней (NewDesignProjectsPage) */
export const NEW_DESIGN_PROJECTS_PATH = '/new/projects';
export const NEW_DESIGN_PROJECT_PARAM = 'project';
/** Таблица проектов старого дизайна */
export const OLD_DESIGN_PROJECTS_PATH = '/projects';

export function readDesign(): Design {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return (DESIGNS as readonly string[]).includes(value ?? '') ? (value as Design) : DEFAULT_DESIGN;
  } catch {
    return DEFAULT_DESIGN;
  }
}

export function rememberDesign(design: Design): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, design);
  } catch {
    // Приватный режим или запрет хранилища: выбор не запомнится, останется дизайн по умолчанию
  }
}

/** Проекты в выбранном дизайне: сюда ведут вход и «Проекты» в меню старой шапки */
export function projectsPathForDesign(design: Design = readDesign()): string {
  return design === 'new' ? NEW_DESIGN_PROJECTS_PATH : OLD_DESIGN_PROJECTS_PATH;
}

/** Проект в новом дизайне: страница проектов с ним выбранным */
export function newDesignProjectPath(projectId: string): string {
  return `${NEW_DESIGN_PROJECTS_PATH}?${new URLSearchParams({ [NEW_DESIGN_PROJECT_PARAM]: projectId })}`;
}
